import { jsx as o } from "react/jsx-runtime";
import { aB as e } from "../../vendor-Dd6qj6gJ.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as t } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index27.css';const i = "_fieldError_taatg_1", f = {
  fieldError: i
};
function d(r) {
  return r.children ? /* @__PURE__ */ o(
    e,
    {
      ...t(r),
      className: f.fieldError,
      "data-component": "FieldError"
    }
  ) : null;
}
export {
  d as FieldError
};
